import '../../css/pages/moments.css';
import { initShell } from '../lib/shell';

initShell();

const filters = document.querySelectorAll<HTMLButtonElement>('.moments-filters__btn');
const items = document.querySelectorAll<HTMLButtonElement>('.moments-item');

filters.forEach((btn) => {
  btn.addEventListener('click', () => {
    filters.forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    const filter = btn.dataset.filter;
    items.forEach((item) => {
      const show = filter === 'all' || item.dataset.category === filter;
      item.classList.toggle('is-hidden', !show);
    });
  });
});

const lightbox = document.getElementById('moments-lightbox');
const lightboxImg = document.getElementById('moments-lightbox-img') as HTMLImageElement | null;
const lightboxCaption = document.getElementById('moments-lightbox-caption');
const lightboxClose = document.getElementById('moments-lightbox-close');

items.forEach((item) => {
  item.addEventListener('click', () => {
    if (lightboxImg) lightboxImg.src = item.dataset.full ?? '';
    if (lightboxCaption) lightboxCaption.textContent = item.dataset.caption ?? '';
    lightbox?.classList.add('is-open');
    lightbox?.setAttribute('aria-hidden', 'false');
  });
});

function closeLightbox(): void {
  lightbox?.classList.remove('is-open');
  lightbox?.setAttribute('aria-hidden', 'true');
}
lightboxClose?.addEventListener('click', closeLightbox);
lightbox?.addEventListener('click', (e) => {
  if (e.target === lightbox) closeLightbox();
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeLightbox();
});
